import axios from "axios";
import {API_HOST} from "@/core/variables";
import {LlmConfig} from "@/model/llmSpecification";

class LlmConfigRepository {
    async find() {
        return axios.get(`${API_HOST}/v1/llm`);
    }

    async update(provider: string, body: LlmConfig) {
        return axios.put(`${API_HOST}/v1/llm/${provider}`, body);
    }
}

const llmConfigRepository = new LlmConfigRepository();
export default llmConfigRepository;